export enum OrderStatus {
  NEW = 'NEW',
  PAYING = 'PAYING',
  CANCELED = 'CANCELED',
  REJECTED = 'REJECTED',
  PAID = 'PAID',
  WAITING_FOR_COURIER = 'WAITING_FOR_COURIER',
  ACCEPTED_BY_RESTAURANT = 'ACCEPTED_BY_RESTAURANT',
  ACCEPTED_BY_COURIER = 'ACCEPTED_BY_COURIER',
  PREPARED = 'PREPARED',
  PICKED_UP = 'PICKED_UP',
  CLOSED = 'CLOSED',
  PAYING_ERROR = 'PAYING_ERROR',
}
